import _ from 'lodash'
import { useCallback } from 'react'
import { useCleanData } from './useCleanData'

export const useCompareData = () => {

  const { cleanUpData } = useCleanData()

  const compareData = useCallback(({ appData, sheetData }) => {
    return compareObjects(appData, sheetData, cleanUpData)
  }, [])

  const getAppDataDiffs = useCallback(({ appData, sheetsData }) => {
    if (_.isEmpty(sheetsData) || _.isEmpty(appData)) return;

    const keys_gs = _.keys(sheetsData)
    const keys_app = _.keys(appData)
    const _keys = _.uniq([
      ...keys_gs,
      ...keys_app
    ]);

    const _appDataDiffs = {}

    _.forEach(_keys, k => {
      const gsi = sheetsData?.[k]
      const appi = appData?.[k]
      const counts = {
        gs: _.size(gsi),
        app: _.size(appi),
        equalCount: false,
        diff: 0
      }
      counts.equalCount = counts.app === counts.gs
      counts.diff = Math.abs(counts.app - counts.gs)
      counts.new = counts.gs - counts.app
      const compares = compareData({ appData: appi, sheetData: gsi })
      _appDataDiffs[k] = { counts, compares }
    })

    return { appDataDiffs: _appDataDiffs }
  }, [])

  return { compareData, getAppDataDiffs }

}
const getFieldDiffs = (appItem, sheetItem) => {
  const fields = _.union(
    _.keys(appItem),
    _.keys(sheetItem)
  )

  return _.reduce(fields, (acc, field) => {
    if (!_.isEqual(appItem[field], sheetItem[field])) {
      acc[field] = {
        app: appItem[field],
        gs: sheetItem[field]
      }
    }

    return acc
  }, {})
}

const normalizeHtmlText = html =>
  String(html || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

const compareObjects = (appData, sheetData, cleanUpData) => {

  const _appData = cleanUpData({ data: appData, removeUnderscores: true })
  const _sheetData = cleanUpData({ data: sheetData, removeUnderscores: true, removeProps: ["itemKey"] })

  const result = {
    appOnly: {},
    sheetsOnly: {},
    different: {},
    differents: {},
    identical: {},
    counts: {
      appOnlyCount: 0,
      sheetsOnlyCount: 0,
      different: 0,
      indentical: 0
    }
  }

  const allKeys = _.union(
    _.keys(_appData),
    _.keys(_sheetData)
  )

  _.forEach(allKeys, key => {
    const appItem = _appData?.[key]
    const sheetItem = _sheetData?.[key]

    if (!sheetItem) {
      result.appOnly[key] = appItem
      return
    }

    if (!appItem) {
      result.sheetsOnly[key] = sheetItem
      return
    }

    const same = normalizeHtmlText(appItem) === normalizeHtmlText(sheetItem)

    if (_.isEqual(appItem, sheetItem) || same) {
      result.identical[key] = appItem
      return
    }

    result.different[key] = {
      app: appItem,
      gs: sheetItem
    }

    result.differents[key] = getFieldDiffs(
      appItem,
      sheetItem
    )

  })

  result.counts.different = _.size(result.different)
  result.counts.appOnlyCount = _.size(result.appOnly)
  result.counts.sheetsOnlyCount = _.size(result.sheetsOnly)
  result.counts.indentical = _.size(result.identical)

  return result
}